<p>client-files works!</p>

<div class="client-files">
  <div class="toolbar">
    <div class="left">
      <strong>Client:</strong>
      <span class="pill">{{ clientCode }}-{{ clientName }}</span>
      <button class="btn" (click)="refresh()" [disabled]="loading">Refresh</button>
      <button class="btn" (click)="loadClientRoot()" [disabled]="loading">Go to Root</button>
    </div>
    <div class="right" *ngIf="loading">
      <span class="spinner"></span> Loading…
    </div>
  </div>
  <div class="error" *ngIf="errorMsg">{{ errorMsg }}</div>
  <div class="breadcrumbs" *ngIf="pathStack.length">
    <ng-container *ngFor="let crumb of pathStack; let i = index">
      <a href (click)="$event.preventDefault(); jumpTo(i)">{{ crumb.name }}</a>
      <span *ngIf="i < pathStack.length - 1"> / </span>
    </ng-container>
  </div>
  <div class="grid" *ngIf="!errorMsg">
    <div
      class="item"
      *ngFor="let it of items"
      [class.folder]="isFolder(it)"
      (click)="isFolder(it) ? enterFolder(it) : open(it)"
      title="{{ it.name }}"
    >
      <img *ngIf="it.iconLink" [src]="it.iconLink" alt="" />
      <div class="name">{{ it.name }}</div>
      <div class="meta">
        <span>{{ it.mimeType }}</span>
        <span *ngIf="it.modifiedTime"> · {{ it.modifiedTime | date:'short' }}</span>
      </div>
    </div>
  </div>
  <div class="load-more" *ngIf="nextPageToken && !loading">
    <button class="btn" (click)="loadMore()">Load more</button>
  </div>
</div>
